import { Component, Inject, Injector } from '@angular/core';
import { Mtrwl } from '../entity/Mtrwl-angular';
import { JackBaseComponentModule } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QuillHtmlComponent } from 'jk-service';
import { JkBaseOption } from 'jk-service';
import { JkDialogEditComponent } from 'jk-service';
import { jkRestReturn } from 'jk-service';
import { JkbtneditComponent } from 'jk-advcom';
import { MtrwlService } from '../_service_mtr';


export class MtrwlPageOption extends JkBaseOption {
  wd015: string = '0';
  simpleVisible: boolean = true;
  constructor(programId: string) {
    super(programId);
  }
}

@Component({
  selector: 'app-mtrwl-edit',
  templateUrl: './mtrwl-edit.component.html',
  styleUrls: ['./mtrwl-edit.component.scss'],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, JkbtneditComponent,
    QuillHtmlComponent,
  ],
})
export class MtrwlEditComponent extends JkDialogEditComponent<MtrwlService, Mtrwl> {
  override srv!: MtrwlService;
  constructor(
    injector: Injector,
    public override dialogRef: MatDialogRef<MtrwlEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(injector, dialogRef, data);
  }
}
